// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2TX-z","productName":"Table_productName__CPWPZ"};